<template>
  <span class="status-label" :class="statusClass(status)">
    {{ statusLabel(status) }}
  </span>
</template>

<script setup>
  defineProps({
    status: String,
  });

  const statusClass = (status) => {
    if (status > 0) {
      return 'done';
    } else {
      return 'default';
    }
  }

  const statusLabel = (status) => {
    if (status > 0) {
      return status + ' курс';
    } else {
      return 'Окончен';
    }
  }
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .status-label {
    padding: 8px 12px;
    border-radius: 2px;
    background-color: $color-text-secondary-grey;
    color: $color-text-secondary-white;
    text-align: center;
    font-family: 'Nunito Sans', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    display: inline-block;
    white-space: nowrap;

    &.default {
      background: $color-bg-status-inwork;
    }

    &.done {
      background: $color-bg-status-done;
    }
  }
</style>
